<small class="media-file-popover" *ngIf="directory" data-test-qa="mediaFilePopover">
  <table class="table-condensed">
    <tr>
      <th translate>Name</th>
      <td>{{directory.name}}</td>
    </tr>
    <tr>
      <th translate>Type</th>
      <td translate>Directory</td>
    </tr>
    <ng-container *ngIf="permission?.showCustomFields">
      <tr *ngFor="let item of fields|keyvalue">
        <th data-test-qa="customFieldName">{{item.key}}</th>
        <td class="no-wrap" data-test-qa="customFieldValue">{{item.value}}</td>
      </tr>
    </ng-container>
    <tr>
      <th translate>Modified</th>
      <td class="no-wrap">
        <div>{{directory.modified|date:'medium'}}</div>
        <div *ngIf="directory.modifiedBy"><i class="far fa-user"></i>&nbsp; {{directory.modifiedBy.displayName}}</div>
      </td>
    </tr>
    <tr *ngIf="directory.childCount">
      <th translate>Items</th>
      <td>{{directory.childCount}}</td>
    </tr>
  </table></small><small class="media-file-popover" *ngIf="bundle?.asset" data-test-qa="mediaFilePopover">
  <table class="table-condensed">
    <tr>
      <th translate>Name</th>
      <td>
        <div>{{bundle.name}}</div>
        <div *ngIf="bundle.mainfile.isHardlink"><i class="far fa-link"></i>
          <translate class="ml-1">Hardlink</translate>
        </div>
      </td>
    </tr>
    <tr *ngIf="bundle.asset.proxiesFailed">
      <th><i class="far fa-exclamation-triangle"></i></th>
      <td translate>Proxy generation failed</td>
    </tr>
    <tr>
      <th translate>Asset ID</th>
      <td class="no-wrap">{{bundle.asset.id || 'Not scanned yet'}}</td>
    </tr>
    <tr *ngIf="root?.workflow &amp;&amp; bundle.asset">
      <th translate>Workflow</th>
      <td><span class="badge no-wrap badge-{{workflow.getState(root, bundle.asset.workflowState)?.color || 'default'}}">{{workflow.getState(root, bundle.asset.workflowState)?.name || 'Unknown state'}}</span></td>
    </tr>
    <tr>
      <th translate>Asset type</th>
      <td class="no-wrap">{{bundle.asset.type || 'Unsupported'|translate}}</td>
    </tr>
    <tr *ngIf="bundle.asset.tags.length &gt; 0 &amp;&amp; (permission?.showTags || bundle.asset.resolvedPermission?.showTags)">
      <th translate>Tags</th>
      <td style="max-width: 180px">
        <media-tag *ngFor="let tag of bundle.asset.tags" [tag]="tag"></media-tag>
      </td>
    </tr>
    <ng-container *ngIf="permission?.showCustomFields">
      <tr *ngFor="let item of fields|keyvalue">
        <th data-test-qa="customFieldName">{{item.key}}</th>
        <td class="no-wrap" data-test-qa="customFieldValue">{{item.value}}</td>
      </tr>
    </ng-container>
    <tr *ngIf="bundle.asset.info.pages">
      <th translate>Pages</th>
      <td class="no-wrap">{{bundle.asset.info.pages}}</td>
    </tr>
    <tr *ngIf="bundle.asset.info.type">
      <th translate>Type</th>
      <td class="no-wrap">{{bundle.asset.info.type}}</td>
    </tr>
    <tr *ngIf="bundle.asset.info.width">
      <th translate>Resolution</th>
      <td class="no-wrap">{{bundle.asset.info.width}}x{{bundle.asset.info.height}}</td>
    </tr>
    <tr *ngIf="bundle.asset.info.duration">
      <th translate>Duration</th>
      <td class="no-wrap">{{bundle.asset.info.duration | time:bundle.asset.info.fps:'full' }}</td>
    </tr>
    <tr *ngIf="bundle.asset.info.timecode">
      <th translate>Timecode</th>
      <td class="no-wrap">{{bundle.asset.info.timecode | time:bundle.asset.info.fps:'full':true }}</td>
    </tr>
    <tr *ngIf="bundle.asset.info.acodec_long">
      <th translate>Audio</th>
      <td class="word-wrap">{{bundle.asset.info.acodec_long}}<span *ngIf="bundle.asset.info.channels">{{bundle.asset.info.channels}} ch</span></td>
    </tr>
    <tr *ngIf="bundle.asset.info.vcodec_long">
      <th translate>Video</th>
      <td class="word-wrap">{{bundle.asset.info.vcodec_long}}</td>
    </tr>
    <tr *ngIf="license.hasComponent(&quot;ltfs&quot;) &amp;&amp; permission?.showLocations &amp;&amp; bundle.asset.backups.length &gt; 0">
      <th translate>Archived</th>
      <td>
        <div class="word-wrap" *ngFor="let backup of bundle.asset.backups"><i class="far fa-fw fa-tape"></i> {{backup.tape_file.tape.name}} {{backup.tape_file.path}}</div>
      </td>
    </tr>
    <tr *ngIf="bundle.asset.bundles.length &gt; 1">
      <th translate>Copies</th>
      <td class="word-wrap">{{bundle.asset.bundles.length}}</td>
    </tr>
    <tr *ngIf="bundle.asset.modified">
      <th translate>Modified</th>
      <td class="no-wrap">
        <div>{{bundle.asset.modified|date:'medium'}}</div>
        <div *ngIf="bundle.asset.modifiedBy"><i class="far fa-user"></i>&nbsp; {{bundle.asset.modifiedBy.displayName}}</div>
      </td>
    </tr>
    <tr *ngIf="bundle.snmAttributes">
      <th translate>Policy</th>
      <td class="word-wrap">{{bundle.snmAttributes.policyClass}}</td>
    </tr>
    <tr *ngIf="bundle.snmAttributes">
      <th translate>Location</th>
      <td class="word-wrap">{{bundle.snmAttributes.location}}</td>
    </tr>
    <tr *ngIf="bundle.snmAttributes">
      <th translate>Archive copies</th>
      <td class="word-wrap">{{bundle.snmAttributes.existingCopies}}</td>
    </tr>
  </table></small>